import { Avatar as MuiAvatar } from '@mui/material';
import DownloadingIcon from '@mui/icons-material/Downloading';

interface AvatarProps {
  name?: string;
}

export const Avatar = (props: AvatarProps) => {
  if (!props.name) {
    return (
      <MuiAvatar
        sx={(theme) => ({
          width: 20,
          height: 20,
          color: theme.vars?.palette.satosRed[500],
          backgroundColor: 'transparent',
        })}
      >
        <DownloadingIcon
          sx={(theme) => ({
            fontSize: theme.fontSizes.f20,
            color: theme.vars?.palette.satosRed[500],
            animation: 'pulse 2s infinite',
            '@keyframes pulse': {
              '0%': { opacity: 0.7 },
              '50%': { opacity: 0.1 },
              '100%': { opacity: 0.7 },
            },
          })}
        />
      </MuiAvatar>
    );
  }

  return <MuiAvatar {...stringAvatar(props.name)} />;
};

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      width: 20,
      height: 20,
      fontSize: 8,
    },
    children: `${name.split(' ')[0]?.[0] ?? ''}${name.split(' ')[1]?.[0] ?? ''}`,
  };
}
